import { required } from "@corporate-tailwind/corp-form";


export class OrderStatusDto { //extends SelectCode {
    id: number | null = null;
    label: string | null = null;
    labelLCode: string | null = null;
    code: string | null = null;
    labelLong: string | null = null;
    labelLongLCode: string | null = null;
    isFailureState: boolean | null = null;
    order: number | null = null;
}

export class OrderStatusSchema extends OrderStatusDto {
    static schema = {
        id: { type: Number, builderOption: required },
        label: { type: String, builderOption: required },
        labelLCode: { type: String, builderOption: required },
        code: { type: String, builderOption: required },

        labelLong: { type: String, builderOption: required },
        labelLongLCode: { type: String, builderOption: required },
        isFailureState: { type: Boolean, builderOption: required }


    }

}